// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2YiSj","header":"MessagesList_header__3v_I7","chat":"MessagesList_chat__29TSL"};